<template>
    <div class="tablePage">
        <el-table v-loading="loading" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
            :header-cell-style="headCellStyle" :height="tableHeight" @selection-change="handleSelectionChange" stripe>
            <el-table-column type="selection" width="50" />
            <el-table-column v-if="isSys" prop="scopeName" :label="$t('public.table_scope')" show-overflow-tooltip />
            <el-table-column prop="plinthCode" :label="$t('integration.number')" show-overflow-tooltip width="200">
                <template #default="{ row }">
                    <i v-icon:theme="['baseTypeConvert', row.type]"></i>
                    <!-- <i v-icon:theme="['equiStatusConvert', row.status]"></i> -->
                    <i v-icon:theme="['baseBindStatusConvert', row.sensorType ? 1 : 0]"></i>
                    <span>{{ row.plinthCode }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="apMacAddr" :label="$t('integration.vcn_switcher_')" show-overflow-tooltip />
            <el-table-column prop="device" :label="$t('integration.bind_device')" show-overflow-tooltip>
                <template #default="{ row }">
                    <template v-if="row.sensorType">
                        <i v-icon:theme="['sensorTypeConvert', row.sensorType]" @click="selectDevice(row)"></i>
                        <span>{{ row.sensorCode }}</span>
                    </template>
                    <template v-else>
                        <span> --- </span>
                    </template>
                </template>
            </el-table-column>

            <el-table-column prop="description" :label="$t('integration.describe')" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="createTime" :label="$t('integration.creation_time')" show-overflow-tooltip>
                <template #default="{ row }">
                    <span>{{ $timetransition(row.createTime) }}</span>
                </template>
            </el-table-column>

            <el-table-column fixed='right' prop="optare" :label="$t('public.table_operation')"  align="center">
                <template #default="{ row }">
                    <el-button type="text" size="small" v-for="item in optareBtn" :key="item.id" :title="$t(item.title)"
                        :icon="item.icon" @click="handle(item.method, row)"></el-button>
                    <!-- v-has="item.vHas" -->
                </template>
            </el-table-column>
        </el-table>
        <SelectDevice :show.sync="selectDeviceAttrs.selectDeviceShow" :sceneId="selectDeviceAttrs.sceneId"
            :baseId="selectDeviceAttrs.baseId" :current="selectDeviceAttrs.current"></SelectDevice>
    </div>
</template>

<script>
import prover from '../components/Proper.vue'
import { gatewayTypeConvert, equiStatusConvert, configStatusConvert, carrierTypeConvert } from '@/utils/convert'
import { btnDetail, btnBindHistory } from '../config/operationButton'
import SelectDevice from '../components/selectDevice/SelectDevice.vue'
export default {
  props: ['loading', 'tableData'],
  computed: {
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      const currentUser = this.$store.getters.userInfo.scope
      if (currentUser.sysScope && currentUser.sysAdmin) {
        // 系统管理员
        return 'isSysAdmin'
      } else if (currentUser.sysScope && !currentUser.sysAdmin) {
        // 系统非管理员
        return 'isSysNoAdmin'
      } else if ((!currentUser.sysScope && currentUser.scopeAdmin) || currentUser.type === 2) {
        // 非系统管理员 以及代理角色  代理角色是迭代7的需求添加
        return 'noSysIsAdmin'
      } else {
        // 非系统非管理员
        return 'noSysNoAdmin'
      }
    }
  },
  components: {
    'v-popoer': prover,
    SelectDevice
  },
  data () {
    return {
      gatewayTypeConvert,
      equiStatusConvert,
      configStatusConvert,
      carrierTypeConvert,
      tableHeight: '100%',
      optareBtn: [btnDetail, btnBindHistory],
      isSys: true,
      selectDeviceAttrs: {
        sceneId: 0,
        selectDeviceShow: false,
        baseId: 0,
        // 当前绑定的sensor
        current: 0
      }
    }
  },

  mounted () {
    if (this.sysAdmin === 'noSysIsAdmin' || this.sysAdmin === 'noSysNoAdmin') {
      this.isSys = false
    }
  },

  methods: {
    handleSelectionChange (row) {
      this.$emit('choozeTable', row)
    },
    handle (method, row) {
      this.$emit(method, row)
    },
    // 选择设备
    selectDevice (row) {
      this.selectDeviceAttrs = {
        selectDeviceShow: true,
        sceneId: row.sceneId,
        baseId: row.id,
        current: row.sensorId
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tablePage {
    height: calc(100% - 60px);
}
</style>
